import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import UserList from './User/UserList';
import UserManage from './User/UserManage';
import EnvironmentList from './Environment/EnvironmentList';
import EnvironmentManage from './Environment/EnvironmentManage';
import AppsList from './Apps/AppsList';
import AppsManage from './Apps/AppsManage';
import ComponentsManage from './Components/ComponentsManage';
import ComponentsList from './Components/ComponentsList';
import { Alert, AlertTitle } from '@material-ui/lab';
import Button from '@material-ui/core/Button';
import Sidebar from './Sidebar'
import * as actions from '../../Store/Actions';


const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(1),
    },
    toolbar: theme.mixins.toolbar,
}));

export default function AdminLayout() {
    const classes = useStyles();
    const reduxAuth = useSelector((state) => state.auth)
    const dispatch = useDispatch();
    let sessionAlert = null;
    if (reduxAuth.isSessionValid === false) {
        sessionAlert = <Alert severity="warning" className={classes.alert} action={
            <Button color="inherit" size="small" onClick={() => dispatch(actions.authLogout())}>
                LOGOUT
                </Button>}>
            <AlertTitle>Error</AlertTitle>
            For security reasons, Your session has expired. Please save your work and re-login to continue.
          </Alert>;
    }
    return (
        <div className={classes.root}>
            <Sidebar></Sidebar>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                {sessionAlert}
                <Switch>
                    {/* <Route exact path="/user">
                        <UserList></UserList>
                    </Route>
                    <Route exact path="/environment/manage">
                        <EnvironmentManage></EnvironmentManage>
                    </Route>
                    <Route exact path="/environment">
                        <EnvironmentList></EnvironmentList>
                    </Route> */}
                    <Route exact path="/apps/manage">
                        <AppsManage></AppsManage>
                    </Route>
                    <Route exact path="/apps">
                        <AppsList></AppsList>
                    </Route>
                    <Route exact path="/components">
                        <ComponentsList></ComponentsList>
                    </Route>
                    <Route exact path="/components/manage">
                        <ComponentsManage></ComponentsManage>
                    </Route>
                    {/* <Route exact path="/user/add">
                        <UserManage></UserManage>
                    </Route> */}
                    <Redirect from="/" to="/apps" />
                </Switch>
            </main>
        </div>
    );
}